import { SignIn } from '@clerk/clerk-react';

export function SignInPage() {
  return (
    <div className="layout" style={{ paddingTop: 48 }}>
      <SignIn routing="path" path="/sign-in" />
    </div>
  );
}
